import { HEROKU_ID_KEY } from 'types'

// PATCH /utility/baseaccount/ can include contact fields and account name /
// address. Copy every defined field, but skip null/undefined so a sparse
// payload cannot blank the existing record.
function definedFieldsToApply(updated) {
  return Object.keys(updated).reduce((fields, key) => {
    if (key === HEROKU_ID_KEY || updated[key] == null) return fields
    return { ...fields, [key]: updated[key] }
  }, {})
}

function mergeMatchingContact(existing, updated) {
  const herokuId = updated?.[HEROKU_ID_KEY]
  if (!existing || !herokuId || existing[HEROKU_ID_KEY] !== herokuId) {
    return existing
  }

  const definedFields = definedFieldsToApply(updated)
  if (!Object.keys(definedFields).length) return existing

  return { ...existing, ...definedFields }
}

function mergeContactInContacts(contacts, updatedContact) {
  if (!contacts || !updatedContact?.[HEROKU_ID_KEY]) return contacts

  return contacts.map((contact) =>
    mergeMatchingContact(contact, updatedContact)
  )
}

export { mergeMatchingContact }
export default mergeContactInContacts
